import React from 'react';

import { SearchContext } from './search-context';

import '../css/search-hits.less';

/**
A component for displaying the total hits for the current search filters
@examples
```jsx
<SearchHits />
```
@component SearchHits
@import SearchHits
@example ../docs/SearchHits.md
@returns {ReactElement} The rendered component
*/
export default class SearchHits extends React.Component {

    static defaultProps = {
        label: 'results'
    }

    render() {
        const { className } = this.props;
        return (
            <SearchContext.Consumer>
             {
                ({hits}) => {
                    return (
                        <span tabIndex={0} className={`search-hits${className ? ' ' + className : ''}`}><span className='count'>{hits}</span> {this.props.label}</span>
                    );
                }
              }
            </SearchContext.Consumer>
        );
    }

}

